import React, { useCallback } from 'react';
import { Checkbox, Tag } from 'antd';

const RewardModalData = ({ rewardList, selectedReward,  setSelectedReward }: any) => {

  const handleCheckboxChange = useCallback((checked: boolean, item: any) => {
    if (checked) {
      setSelectedReward((prevSelectedReward:any) => [...prevSelectedReward, item]);
    } else {
      setSelectedReward((prevSelectedReward:any) => prevSelectedReward.filter((reward: any) => reward !== item));
    }
  }, [setSelectedReward]);


  return (
    <div className='p-10'>
      {rewardList && rewardList?.map((item: any, index: number) => {
        return (
          <Checkbox
            key={index}
            value={item}
            style={{ marginBottom: '10px' }}
            onChange={(e) => handleCheckboxChange(e.target.checked, item)}
          >
            <span style={{ marginBottom: '10px' }}>
              {item.label}
              <span style={{ marginLeft: '10px' }}>
                <Tag color='magenta'>
                  {item?.referralRewardType === 'percentage' ?
                    `${item?.referralRewardValue} % Commission` :
                    item?.referralRewardType === 'cash' ?
                      `$ ${item?.referralRewardValue} Cash Reward` :
                      item?.referralRewardType === 'no-reward' ?
                        `Voucher or Freebie` :
                        item?.referralRewardType === 'coupon' ?
                          `${item?.referralRewardValue} Voucher or Freebie` : ""}
                </Tag>
              </span>
            </span>
          </Checkbox>
        );
      })}
    </div>
  );
};

export default RewardModalData;